import { CardTableBaseProps } from "../interface";
import { formatCardTableData } from "../util";

export const initCardTable: CardTableBaseProps = {
  loading: false,
  dataSource: [],
}; 

export interface CardTableReducerAction {
  type: CardTableReducerActionType;
  payload?: CardTableBaseProps;
};

export type CardTableReducerActionType = "FETCH_INIT" | "FETCH_SUCCESS" | "FETCH_ERROR" | "CHANGE_DATA";

function useCardTableReducer(state: CardTableBaseProps, action: CardTableReducerAction): CardTableBaseProps {
  const { statueFiled } = state;
  const { dataSource } = action.payload ?? {};
  switch (action.type) {
    case "FETCH_INIT": {
      return {
        ...state,
        loading: true,
      }
    }
    case "FETCH_SUCCESS": {
      formatCardTableData
      return {
        ...state,
        dataSource: formatCardTableData(dataSource, statueFiled),
        list: dataSource,
        loading: false,
      }
    }
    case "CHANGE_DATA": {
      return {
        ...state,
        dataSource: formatCardTableData(dataSource, statueFiled),
        list: dataSource,
      }
    }
    case "FETCH_ERROR": {
      return {
        ...state,
        dataSource: [],
        list: [],
        loading: false,
      }
    }
    default: {
      throw Error('未知 action：' + action.type);
    }
  }
}

export default useCardTableReducer;
